import Notification from "../entities/notification/Notification";
import { getLabelsByLanguage } from "../utilites/util";

export default class NotificationFactory {

  static create(flashMessage: any) {
    return new Notification(
      flashMessage.id,
      flashMessage.type,
      flashMessage.message,
      this.getCssClassByType(flashMessage.type),
    );
  }

  public static getCssClassByType(type: string) {
    switch (type) {
    case 'info':
      return 'alert-info';
    case 'warning':
      return 'alert-warning';
    case 'error':
    case 'critical':
      return 'alert-danger';
    }

    return 'alert-info';
  }

  public static createFromErrorResponse(error: any) {
    const labels =  getLabelsByLanguage();
    const message = typeof error.userMessage === 'string' ? error.userMessage : labels.errorMessage;

    return new Notification(
      Date.now() + (Math.floor(Math.random() * 1000) + 1),
      'critical',
      message,
      this.getCssClassByType('critical'),
    );
  }

}
